import React from "react";
import { NavLink, useLocation, useNavigate } from "react-router-dom";
import {
  NXSettings,
  NXUserAdmin,
  NXDollarCircle2,
  NXTablerLink,
  NXLock,
  NXCross,
  NXLogout,
  NXBagDollar,
  NXMonitor,
  NXInvoice,
  NXWarehouse,
} from "../../icons"; // Import your icons here
import useApi from "../../api";
import { useDispatch } from "react-redux";
import { logout } from "../../redux/authSlice";
import NXShipping from "../../icons/NXShipping";
import { useOutsideClick } from "../common/useOutsideClick";

interface SidebarProps {
  handleClose: () => void;
}


const Sidebar: React.FC<SidebarProps> = ({handleClose}) => {
  const dispatch = useDispatch()
  const { pathname } = useLocation();
  const navigate = useNavigate()

  const api = useApi();

  const handleLogout = () => {
    api.adminLogout().then(() => {
      dispatch(logout())
      navigate('/dashboard/login')
    }).catch((error: any) => {
      dispatch(logout())
      navigate('/dashboard/login')
      console.error(error)
    })
    
   
  }

  const ref = useOutsideClick(handleClose) 

  return (
    <div className="bg-white mh:bg-transparent border-r-2 mh:border-none mh:shadow-none h-full" ref={ref}>
      <div className="flex justify-end p-2 cursor-pointer mh:hidden" onClick={handleClose}><NXCross className="h-5"/></div>
      <ul className="mh:block list-none">
        <li>
          <NavLink
            to="/dashboard/settings/"
            onClick={handleClose}
            className={`font-bold text-sm flex items-center gap-4 py-4 px-2 mb-1 rounded-md  hover:bg-secondary-100 ${
              pathname === "/dashboard/settings/" ? "bg-secondary-100" : ""
            } bg-slate-20`}
          >
            <NXSettings />
            General
          </NavLink>
        </li>
        <li>
          <NavLink
            to="/dashboard/settings/invoice/"
            onClick={handleClose}
            className={`font-bold text-sm flex items-center gap-4 py-4 px-2 mb-1 rounded-md  hover:bg-secondary-100 ${
              pathname === "/dashboard/settings/invoice/" ? "bg-secondary-100" : ""
            } bg-slate-20`}
          >
            <NXInvoice className="w-[23px] h-[23px] p-[1px]" />
            Invoice
          </NavLink>
        </li>
        <li className="">
          <NavLink
            to="/dashboard/settings/account"
            onClick={handleClose}
            className={`font-bold text-sm flex items-center gap-4 py-4 px-2 mb-1 rounded-md  hover:bg-secondary-100 ${
              pathname === "/dashboard/settings/account"
                ? "bg-secondary-100"
                : ""
            } bg-slate-20`}
          >
            <NXUserAdmin />
            Account
          </NavLink>
        </li>
        <li>
          <NavLink
            to="/dashboard/settings/payment-and-billing"
            onClick={handleClose}
            className={`font-bold text-sm flex items-center gap-4 py-4 px-2 mb-1 rounded-md  hover:bg-secondary-100 ${
              pathname === "/dashboard/settings/payment-and-billing"
                ? "bg-secondary-100"
                : ""
            } bg-slate-20`}
          >
            <NXDollarCircle2 className="stroke-black" />
            Payment and billing
          </NavLink>
        </li>
        <li>
          <NavLink
            to="/dashboard/settings/link-account"
            onClick={handleClose}
            className={`font-bold text-sm flex items-center gap-4 py-4 px-2 mb-1 rounded-md  hover:bg-secondary-100 ${
              pathname === "/dashboard/settings/link-account"
                ? "bg-secondary-100"
                : ""
            } bg-slate-20`}
          >
            <NXTablerLink />
            Link Account
          </NavLink>
        </li>
        <li>
          <NavLink
            to="/dashboard/settings/password"
            onClick={handleClose}
            className={`font-bold text-sm flex items-center gap-4 py-4 px-2 mb-1 rounded-md  hover:bg-secondary-100 ${
              pathname === "/dashboard/settings/password"
                ? "bg-secondary-100"
                : ""
            } bg-slate-20`}
          >
            <NXLock />
            Password
          </NavLink>
        </li>
        {/* <li>
          <NavLink
            to="/dashboard/settings/push-notification"
            onClick={handleClose}
            className={`font-bold text-sm flex items-center gap-4 py-4 px-2 mb-1 rounded-md  hover:bg-secondary-100 ${
              pathname === "/dashboard/settings/push-notification"
                ? "bg-secondary-100"
                : ""
            } bg-slate-20`}
          >
            <NXbell />
            Push notification
          </NavLink>
        </li> */}
        <li>
          <NavLink
            to="/dashboard/settings/tax-class"
            onClick={handleClose}
            className={`font-bold text-sm flex items-center gap-4 py-4 px-2 mb-1 rounded-md  hover:bg-secondary-100 ${
              pathname === "/dashboard/settings/tax-class"
                ? "bg-secondary-100"
                : ""
            } bg-slate-20`}
          >
            <NXBagDollar className="pl-1 stroke-black"/>
            Tax class
          </NavLink>
        </li>
        <li>
          <NavLink
            to="/dashboard/settings/shipping"
            onClick={handleClose}
            className={`font-bold text-sm flex items-center gap-4 py-4 px-2 mb-1 rounded-md  hover:bg-secondary-100 ${
              pathname === "/dashboard/settings/shipping"
                ? "bg-secondary-100"
                : ""
            } bg-slate-20`}
          >
            <NXShipping className="pl-1 w-6 h-6 stroke-black"/>
            Shipping
          </NavLink>
        </li>
        <li>
          <NavLink
            to="/dashboard/settings/status"
            onClick={handleClose}
            className={`font-bold text-sm flex items-center gap-4 py-4 px-2 mb-1 rounded-md  hover:bg-secondary-100 ${
              pathname === "/dashboard/settings/status"
                ? "bg-secondary-100"
                : ""
            } bg-slate-20`}
          >
            <NXMonitor className="pl-1 w-6 h-6 stroke-black"/>
            Status
          </NavLink>
        </li>
        <li>
          <NavLink
            to="/dashboard/settings/warehouse"
            onClick={handleClose}
            className={`font-bold text-sm flex items-center gap-4 py-4 px-2 mb-1 rounded-md  hover:bg-secondary-100 ${
              pathname === "/dashboard/settings/warehouse"
                ? "bg-secondary-100"
                : ""
            } bg-slate-20`}
          >
            <NXWarehouse className="pl-1 w-6 h-6 stroke-black"/>
            Warehouse
          </NavLink>
        </li>
      </ul>
      <button onClick={handleLogout} className="mt-4 text-base font-bold bg-red-600 text-white rounded-md flex justify-center gap-4 items-center py-2 w-full hover:bg-red-700 transition-all duration-150 ease-linear" >
        <NXLogout className="stroke-white h-[20px] w-[20px]"/>
          Logout
      </button>
    </div>
  );
};

export default Sidebar;
